import axios from 'axios';
import type { SiteId } from '@hotjar/site';
import { mapRecentSurveysResponseDtoToModel } from './mapper';
import type { RecentSurvey } from './types';
import type { RecentSurveyDto, PollId } from './dto';

function getEndpointPath(siteId: SiteId, pollId?: PollId): string {
  const path = `/api/v1/sites/${siteId}/surveys`;
  if (pollId) {
    return `${path}/${pollId}`;
  }
  return path;
}

export async function getRecentSurveys(siteId: SiteId): Promise<RecentSurvey[]> {
  const path = getEndpointPath(siteId);
  const query = `?limit=3`;
  const response = await axios.get<RecentSurveyDto[]>(`${path}${query}`);
  return mapRecentSurveysResponseDtoToModel(response.data);
}
